import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment-timezone';
import toast from "react-hot-toast";

import { USER_LOGGED_IN } from "../../../Reducer/authSlice";
import StudentSettingNav from "./StudentSettingNav";
import API from "../../../Network/API";
import { useTranslation } from "react-i18next";
export default function ProfileSetting() {
    const { t } = useTranslation();
    const { user, accessToken } = useSelector((state) => state.authReducer);
    const select_language = useSelector((state) => state.languageReducer);
    const select_country = useSelector((state) => state.countryReducer);
    const [timezones, setTimezones] = useState([]);
    const [country_id, setCountryId] = useState(0);
    const [selectedTimeZone, setTimeZoneId] = useState();
    const [photoURL, setPhotoURL] = useState(user?.avatar);
    const [file, setFile] = useState(null);
    const [hideAvatar, setHideAvatar] = useState(!!user?.is_avatar_blur);
    const [loading, setLoad] = useState(false);
    const dispatch = useDispatch();
    const onChangeTimeZone = (e) => {

        setTimeZoneId(e?.value != null ? e?.value : '')
    };

    useEffect(() => {
        const tzNames = moment.tz.names();
        const newOptions = tzNames.map(tz => ({
            value: tz, // Assuming you want the ID as a string
            label: tz
        }));
        setTimezones(newOptions);

    }, []);

    const setSelectedFile = (e) => {
        setFile(e.target.files[0])
        setPhotoURL(URL.createObjectURL(e.target.files[0]))
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setLoad(true);

        if (event.target.name.value == "") {
            toast.error(t('profileSetting.name_required'))
            return false;
        }

        const fd = new FormData();
        fd.append('name', user?.name)
        fd.append('gender_id', user?.gender_id)
        fd.append('country', event.target.country.value)
        fd.append('phone', event.target.phone.value)
        fd.append('timezone', event.target.timezone.value)
        fd.append('is_avatar_blur', hideAvatar ? 1 : 0)

        if (file) {
            fd.append('image', file, file?.name)
        }

        API.post("/v1/oauth/student/profile-update", fd, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: progressEvent => {
                console.log("Progress: " + progressEvent.loaded / progressEvent.total);
            }
        }).then((response) => {
            setLoad(false)
            toast.success(t('profileSetting.profile_update_success'));
            localStorage.setItem(
                'xller_auth',
                JSON.stringify({
                    user: response?.data?.data?.user,
                    accessToken: localStorage.getItem('xller_token'),
                })
            )

            const userInfo = JSON.parse(localStorage.getItem("xller_auth"));
            if (userInfo) {
                dispatch(USER_LOGGED_IN(userInfo));
            }

        }).catch((err) => {
            setLoad(false)
            toast.error(err?.response?.data?.message || t('profileSetting.update_failed'));
        });
    }
    return (<>

        <div className="settings-widget card-details shadow-sm">
            <div className="settings-menu p-0">
                <div className="profile-heading">
                    <h3>{t('profileSetting.settings')}</h3>
                    <p>{t('profileSetting.settings_subtitle')}</p>
                </div>
                <div className="settings-page-head">
                    <StudentSettingNav active_menu={`profile`}/>
                </div>
                <form  onSubmit={handleSubmit} >
                    <div className="course-group profile-upload-group mb-0 d-flex">
                        <div className="course-group-img profile-edit-field d-flex align-items-center">
                            <a href="#" className="profile-pic"><img src={photoURL} alt={user?.name} className={`img-fluid ${hideAvatar ? 'avatar-blur-preview' : ''}`} /></a>
                            <div className="profile-upload-head">
                                <h4><a href="#">{t('profileSetting.your_avatar')}</a></h4>
                                <p>{t('profileSetting.avatar_hint')}</p>
                                <div className="new-employee-field">
                                    <div className="d-flex align-items-center mt-2">
                                        <div className="image-upload mb-0">
                                            <input type="file" onChange={(e) => setSelectedFile(e)}/>
                                            <div className="image-uploads">
                                                <i className="fa-light fa-cloud-upload" />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                <div className="form-check form-switch avatar-privacy-toggle mt-3">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        role="switch"
                                        id="hideAvatarSwitch"
                                        checked={hideAvatar}
                                        onChange={(e) => setHideAvatar(e.target.checked)}
                                    />
                                    <label className="form-check-label" htmlFor="hideAvatarSwitch">
                                        {t('profileSetting.hide_profile_photo')}
                                    </label>
                                    <p className="avatar-privacy-note mb-0">
                                        {t('profileSetting.hide_photo_note')}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="checkout-form settings-wrap">
                        <div className="edit-profile-info">
                            <h5>{t('profileSetting.personal_details')}</h5>
                            <p>{t('profileSetting.edit_personal_info')}</p>
                        </div>
                        <div className="form-group mb-3 row">
                            <div className="col-6">
                                <label htmlFor="First_name" className="form-label ">{t('profileSetting.name')}</label>
                                <input disabled required name="name" defaultValue={user?.name} type="text" className="form-control rounded input-hight-44" id="First_name" placeholder={t('profileSetting.first_name_placeholder')} />
                            </div>
                            <div className="col-6">
                                <label htmlFor="Last_name" className="form-label ">{t('profileSetting.gender')}</label>
                                <select disabled className="form-select input-hight-44" name="gender_id" required>
                                    <option value={``}>{t('profileSetting.select_gender')}</option>
                                    <option selected={user?.gender_id == 1 ? true : false} value={1}>{t('profileSetting.male')}</option>
                                    <option selected={user?.gender_id == 2 ? true : false} value={2}>{t('profileSetting.female')}</option>
                                </select>
                            </div>
                        </div>
                        <div className="form-group mb-3 row">
                            <div className="col-6">
                                <label  className="form-label ">{t('profileSetting.country')} </label>
                                <select required name="country" className="form-select input-hight-44">
                                    {!select_country?.loading && select_country?.data?.map(country => (
                                        <option selected={country.code == user?.teacher_info?.country ? true : false} value={country.code}>{country.name}</option>
                                    ))}
                                </select>
                            </div>
                            <div className="col-6">
                                <label className="form-label ">{t('profileSetting.timezone')} </label>

                                <select required name="timezone" className="form-select input-hight-44">
                                    {timezones?.map(timezone => (
                                        <option selected={timezone.label == user?.teacher_info?.timezone ? true : false} value={timezone.value}>{timezone.label}</option>
                                    ))}
                                </select>

                            </div>
                        </div>
                        <div className="form-group mb-3 row">
                            <div className="col-6">
                                <label className="form-label ">{t('profileSetting.phone_optional')}</label>
                                <div className="input-group">
                                    <input name="phone" defaultValue={user?.teacher_info?.phone} type="text" className="form-control input-hight-44  fc-phone" />
                                </div>
                            </div>
                            
                         
                        </div>
                       

                        

                        <div className="mb-3 d-flex justify-content-end ">
                            <button type="submit" className="input-hight-44 btn btn-login box-shadow-1 fw-bold">{t('profileSetting.update')} {loading ? (
                                                    <span
                                                      className="spinner-border spinner-border-sm ml-5"
                                                      role="status"
                                                      aria-hidden="true"
                                                    ></span>
                                                  ) : (
                                                    <span></span>
                                                  )}</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>

    </>)
}